import BuyIcon from '#/assets/BuyIcon';
import SellIcon from '#/assets/SellIcon';

export default function OrderSideIcon({ side }: { side: 'BUY' | 'SELL' }) {
  return side === 'BUY' ? <BuyIcon size={19} /> : <SellIcon size={19} />;
}
